import { selectThemeStyle } from '../../../features/setting/setting.slice.ts'
import { useAppSelector } from '../../../redux/hooks.ts'
import { convertPxToNumber, isV2Ready } from '../../../utils/helpers.ts'
import { IdeyaButton } from '../../../common/antd/ideya-button/ideya-button.tsx'
import Col from 'antd/es/grid/col'
import Row from 'antd/es/grid/row'
import { useTranslation } from 'react-i18next'
import { useIsSuperViewer } from '../../../common/hooks/use-is-superviewer.ts'

interface FirmManagementUserControlsProps {
  onCreateFirm: () => void
}

export const FirmManagementUserControls: React.FC<
  FirmManagementUserControlsProps
> = ({ onCreateFirm }) => {
  const { t } = useTranslation()
  const themeStyle = useAppSelector(selectThemeStyle)
  const isSuperViewer = useIsSuperViewer()

  return (
    <Row
      align={'bottom'}
      justify={'space-between'}
      style={{ marginBottom: themeStyle.marginSM }}
    >
      <Col>
        {isV2Ready && (
          <Row
            gutter={[
              convertPxToNumber(themeStyle.marginXS),
              convertPxToNumber(themeStyle.marginXS),
            ]}
          >
            <Col>
              <IdeyaButton ghost>Expand All</IdeyaButton>
            </Col>
            <Col>
              <IdeyaButton ghost>Collapse All</IdeyaButton>
            </Col>
          </Row>
        )}
      </Col>
      {!isSuperViewer && (
        <Col>
          <IdeyaButton onClick={onCreateFirm}>
            {t('firm_management.firm_modal.add_firm')}
          </IdeyaButton>
        </Col>
      )}
    </Row>
  )
}
